module.exports = __webpack_public_path__ + "img/00018.d99ac003.webp";